import { GetJobRatingStatusResponse } from '@taxfyle/api-internal/internal/job_rating_pb'

export const allRatingStatuses = [
  'Disabled',
  'Pending',
  'Rated',
  'NotReady',
  'NotApplicable',
  'Unknown',
] as const

export type RatingStatus = (typeof allRatingStatuses)[number]

export interface JobRatingStatus {
  proRating: RatingStatus
  platformRating: RatingStatus
}

/**
 * Maps a GetJobRatingStatusResponse.Status to a RatingStatus.
 * @param status - The status to map.
 * @returns The mapped RatingStatus.
 */
export function mapJobRatingStatus(status: GetJobRatingStatusResponse.Status) {
  switch (status) {
    case GetJobRatingStatusResponse.Status.PENDING:
      return 'Pending'
    case GetJobRatingStatusResponse.Status.NOT_READY:
      return 'NotReady'
    case GetJobRatingStatusResponse.Status.RATED:
      return 'Rated'
    case GetJobRatingStatusResponse.Status.DISABLED:
      return 'Disabled'
    case GetJobRatingStatusResponse.Status.NOT_APPLICABLE:
      return 'NotApplicable'
    default:
      return 'Unknown'
  }
}

/**
 * Maps a GetJobRatingStatusResponse.AsObject to a JobRatingStatus.
 * @param jobRatingStatusDto - The DTO to map.
 * @returns The mapped JobRatingStatus.
 */
export function mapToJobRatingStatuses(
  jobRatingStatusDto: GetJobRatingStatusResponse,
): JobRatingStatus {
  return {
    proRating: mapJobRatingStatus(jobRatingStatusDto.getProRating()),
    platformRating: mapJobRatingStatus(jobRatingStatusDto.getPlatformRating()),
  }
}
